// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/portfolio.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * MoneyTotal is one currency's total (never converted); amount is a decimal string.
 *
 * @generated from message mono.projectdata.v1.MoneyTotal
 */ export class MoneyTotal extends Message {
    static fromBinary(bytes, options) {
        return new MoneyTotal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MoneyTotal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MoneyTotal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MoneyTotal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string currency = 1;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string amount = 2;
   */ _define_property(this, "amount", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MoneyTotal, "runtime", proto3);
_define_property(MoneyTotal, "typeName", "mono.projectdata.v1.MoneyTotal");
_define_property(MoneyTotal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * EconomicsFigures keeps each value kind separate; kinds are never summed together.
 *
 * @generated from message mono.projectdata.v1.EconomicsFigures
 */ export class EconomicsFigures extends Message {
    static fromBinary(bytes, options) {
        return new EconomicsFigures().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EconomicsFigures().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EconomicsFigures().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EconomicsFigures, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 opportunity_count = 1;
   */ _define_property(this, "opportunityCount", protoInt64.zero), /**
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal deal = 2;
   */ _define_property(this, "deal", []), /**
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal share = 3;
   */ _define_property(this, "share", []), /**
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal bid = 4;
   */ _define_property(this, "bid", []), /**
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal award = 5;
   */ _define_property(this, "award", []), /**
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal revenue = 6;
   */ _define_property(this, "revenue", []), /**
   * @generated from field: int64 pursuit_count = 7;
   */ _define_property(this, "pursuitCount", protoInt64.zero), /**
   * @generated from field: int64 proposal_count = 8;
   */ _define_property(this, "proposalCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(EconomicsFigures, "runtime", proto3);
_define_property(EconomicsFigures, "typeName", "mono.projectdata.v1.EconomicsFigures");
_define_property(EconomicsFigures, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "deal",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 3,
            name: "share",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 4,
            name: "bid",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 5,
            name: "award",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 6,
            name: "revenue",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 7,
            name: "pursuit_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 8,
            name: "proposal_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LandscapeEconomics
 */ export class LandscapeEconomics extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeEconomics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeEconomics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeEconomics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeEconomics, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: mono.projectdata.v1.EconomicsFigures figures = 3;
   */ _define_property(this, "figures", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeEconomics, "runtime", proto3);
_define_property(LandscapeEconomics, "typeName", "mono.projectdata.v1.LandscapeEconomics");
_define_property(LandscapeEconomics, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "figures",
            kind: "message",
            T: EconomicsFigures
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPortfolioEconomicsRequest
 */ export class GetPortfolioEconomicsRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioEconomicsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioEconomicsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioEconomicsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioEconomicsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty = the whole portfolio and every live Landscape.
   *
   * @generated from field: repeated string landscape_ids = 1;
   */ _define_property(this, "landscapeIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioEconomicsRequest, "runtime", proto3);
_define_property(GetPortfolioEconomicsRequest, "typeName", "mono.projectdata.v1.GetPortfolioEconomicsRequest");
_define_property(GetPortfolioEconomicsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPortfolioEconomicsResponse
 */ export class GetPortfolioEconomicsResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPortfolioEconomicsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPortfolioEconomicsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPortfolioEconomicsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPortfolioEconomicsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.EconomicsFigures portfolio = 1;
   */ _define_property(this, "portfolio", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.LandscapeEconomics landscapes = 2;
   */ _define_property(this, "landscapes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPortfolioEconomicsResponse, "runtime", proto3);
_define_property(GetPortfolioEconomicsResponse, "typeName", "mono.projectdata.v1.GetPortfolioEconomicsResponse");
_define_property(GetPortfolioEconomicsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "portfolio",
            kind: "message",
            T: EconomicsFigures
        },
        {
            no: 2,
            name: "landscapes",
            kind: "message",
            T: LandscapeEconomics,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetOpportunityValueRequest
 */ export class SetOpportunityValueRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityValueRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityValueRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityValueRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityValueRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * Empty = the parent-level value.
   *
   * @generated from field: string lot_id = 2;
   */ _define_property(this, "lotId", ""), /**
   * deal | share | bid | award | revenue
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string amount = 4;
   */ _define_property(this, "amount", ""), /**
   * Empty = USD.
   *
   * @generated from field: string currency = 5;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string source = 6;
   */ _define_property(this, "source", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityValueRequest, "runtime", proto3);
_define_property(SetOpportunityValueRequest, "typeName", "mono.projectdata.v1.SetOpportunityValueRequest");
_define_property(SetOpportunityValueRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lot_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetOpportunityValueResponse
 */ export class SetOpportunityValueResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetOpportunityValueResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetOpportunityValueResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetOpportunityValueResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetOpportunityValueResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string lot_id = 3;
   */ _define_property(this, "lotId", ""), /**
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string amount = 5;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string currency = 6;
   */ _define_property(this, "currency", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetOpportunityValueResponse, "runtime", proto3);
_define_property(SetOpportunityValueResponse, "typeName", "mono.projectdata.v1.SetOpportunityValueResponse");
_define_property(SetOpportunityValueResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lot_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateOpportunityLotRequest
 */ export class CreateOpportunityLotRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateOpportunityLotRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOpportunityLotRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOpportunityLotRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOpportunityLotRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOpportunityLotRequest, "runtime", proto3);
_define_property(CreateOpportunityLotRequest, "typeName", "mono.projectdata.v1.CreateOpportunityLotRequest");
_define_property(CreateOpportunityLotRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.CreateOpportunityLotResponse
 */ export class CreateOpportunityLotResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateOpportunityLotResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateOpportunityLotResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateOpportunityLotResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateOpportunityLotResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * @generated from field: bool created = 4;
   */ _define_property(this, "created", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateOpportunityLotResponse, "runtime", proto3);
_define_property(CreateOpportunityLotResponse, "typeName", "mono.projectdata.v1.CreateOpportunityLotResponse");
_define_property(CreateOpportunityLotResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * A dated owning row contributing to a current figure. Amount is decimal.
 *
 * @generated from message mono.projectdata.v1.ComparisonSource
 */ export class ComparisonSource extends Message {
    static fromBinary(bytes, options) {
        return new ComparisonSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComparisonSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComparisonSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComparisonSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string lot_id = 3;
   */ _define_property(this, "lotId", ""), /**
   * @generated from field: string kind = 4;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string amount = 5;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string currency = 6;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string date = 7;
   */ _define_property(this, "date", ""), /**
   * @generated from field: string date_field = 8;
   */ _define_property(this, "dateField", ""), /**
   * @generated from field: string provenance = 9;
   */ _define_property(this, "provenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComparisonSource, "runtime", proto3);
_define_property(ComparisonSource, "typeName", "mono.projectdata.v1.ComparisonSource");
_define_property(ComparisonSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lot_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "date_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Recorded market estimate: may overlap other observations, never actual
 * revenue or a claim to total market. Absent amount means unknown, not zero.
 *
 * @generated from message mono.projectdata.v1.MarketObservation
 */ export class MarketObservation extends Message {
    static fromBinary(bytes, options) {
        return new MarketObservation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarketObservation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarketObservation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarketObservation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: optional string amount = 3;
   */ _define_property(this, "amount", void 0), /**
   * @generated from field: string currency = 4;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarketObservation, "runtime", proto3);
_define_property(MarketObservation, "typeName", "mono.projectdata.v1.MarketObservation");
_define_property(MarketObservation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.HypothesisVersion
 */ export class HypothesisVersion extends Message {
    static fromBinary(bytes, options) {
        return new HypothesisVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new HypothesisVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new HypothesisVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(HypothesisVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int64 version = 2;
   */ _define_property(this, "version", protoInt64.zero), /**
   * @generated from field: string hypothesis = 3;
   */ _define_property(this, "hypothesis", ""), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 5;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(HypothesisVersion, "runtime", proto3);
_define_property(HypothesisVersion, "typeName", "mono.projectdata.v1.HypothesisVersion");
_define_property(HypothesisVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * Permitted frozen publication and its live status. No raw-source identity.
 *
 * @generated from message mono.projectdata.v1.LandscapeIntelligence
 */ export class LandscapeIntelligence extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeIntelligence().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeIntelligence().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeIntelligence().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeIntelligence, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string library_item_id = 1;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 2;
   */ _define_property(this, "releaseId", ""), /**
   * @generated from field: int64 version = 3;
   */ _define_property(this, "version", protoInt64.zero), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string summary = 5;
   */ _define_property(this, "summary", ""), /**
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string reviewed_at = 7;
   */ _define_property(this, "reviewedAt", ""), /**
   * @generated from field: string released_at = 8;
   */ _define_property(this, "releasedAt", ""), /**
   * @generated from field: string status = 9;
   */ _define_property(this, "status", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeIntelligence, "runtime", proto3);
_define_property(LandscapeIntelligence, "typeName", "mono.projectdata.v1.LandscapeIntelligence");
_define_property(LandscapeIntelligence, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "version",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reviewed_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "released_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeComparisonRequest
 */ export class GetLandscapeComparisonRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeComparisonRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeComparisonRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeComparisonRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeComparisonRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeComparisonRequest, "runtime", proto3);
_define_property(GetLandscapeComparisonRequest, "typeName", "mono.projectdata.v1.GetLandscapeComparisonRequest");
_define_property(GetLandscapeComparisonRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeComparisonResponse
 */ export class GetLandscapeComparisonResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeComparisonResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeComparisonResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeComparisonResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeComparisonResponse, a, b);
    }
    constructor(data){
        super(), /**
   * Populated at the authorized browser facade by canonical LAND-09 economics.
   *
   * @generated from field: mono.projectdata.v1.EconomicsFigures current = 1;
   */ _define_property(this, "current", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.ComparisonSource current_sources = 2;
   */ _define_property(this, "currentSources", []), /**
   * Denominator for each current kind/currency; known = distinct opportunity IDs
   * in that source group. Unknown opportunities never become zero-valued rows.
   *
   * @generated from field: int64 current_opportunity_count = 3;
   */ _define_property(this, "currentOpportunityCount", protoInt64.zero), /**
   * @generated from field: repeated mono.projectdata.v1.MarketObservation market_observations = 4;
   */ _define_property(this, "marketObservations", []), /**
   * Server sums known recorded estimates only, separately by currency.
   *
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal market_totals = 5;
   */ _define_property(this, "marketTotals", []), /**
   * @generated from field: repeated mono.projectdata.v1.ComparisonCoverage current_coverage = 6;
   */ _define_property(this, "currentCoverage", []), /**
   * @generated from field: repeated mono.projectdata.v1.ComparisonCoverage market_coverage = 7;
   */ _define_property(this, "marketCoverage", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeComparisonResponse, "runtime", proto3);
_define_property(GetLandscapeComparisonResponse, "typeName", "mono.projectdata.v1.GetLandscapeComparisonResponse");
_define_property(GetLandscapeComparisonResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "current",
            kind: "message",
            T: EconomicsFigures
        },
        {
            no: 2,
            name: "current_sources",
            kind: "message",
            T: ComparisonSource,
            repeated: true
        },
        {
            no: 3,
            name: "current_opportunity_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "market_observations",
            kind: "message",
            T: MarketObservation,
            repeated: true
        },
        {
            no: 5,
            name: "market_totals",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 6,
            name: "current_coverage",
            kind: "message",
            T: ComparisonCoverage,
            repeated: true
        },
        {
            no: 7,
            name: "market_coverage",
            kind: "message",
            T: ComparisonCoverage,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddMarketObservationRequest
 */ export class AddMarketObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new AddMarketObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddMarketObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddMarketObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddMarketObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: optional string amount = 3;
   */ _define_property(this, "amount", void 0), /**
   * @generated from field: string currency = 4;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: string provenance = 6;
   */ _define_property(this, "provenance", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddMarketObservationRequest, "runtime", proto3);
_define_property(AddMarketObservationRequest, "typeName", "mono.projectdata.v1.AddMarketObservationRequest");
_define_property(AddMarketObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            opt: true
        },
        {
            no: 4,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AddMarketObservationResponse
 */ export class AddMarketObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new AddMarketObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AddMarketObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AddMarketObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AddMarketObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.MarketObservation observation = 1;
   */ _define_property(this, "observation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AddMarketObservationResponse, "runtime", proto3);
_define_property(AddMarketObservationResponse, "typeName", "mono.projectdata.v1.AddMarketObservationResponse");
_define_property(AddMarketObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "observation",
            kind: "message",
            T: MarketObservation
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeHypothesesRequest
 */ export class GetLandscapeHypothesesRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeHypothesesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeHypothesesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeHypothesesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeHypothesesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeHypothesesRequest, "runtime", proto3);
_define_property(GetLandscapeHypothesesRequest, "typeName", "mono.projectdata.v1.GetLandscapeHypothesesRequest");
_define_property(GetLandscapeHypothesesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeHypothesesResponse
 */ export class GetLandscapeHypothesesResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeHypothesesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeHypothesesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeHypothesesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeHypothesesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.HypothesisVersion versions = 1;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeHypothesesResponse, "runtime", proto3);
_define_property(GetLandscapeHypothesesResponse, "typeName", "mono.projectdata.v1.GetLandscapeHypothesesResponse");
_define_property(GetLandscapeHypothesesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "versions",
            kind: "message",
            T: HypothesisVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AppendLandscapeHypothesisRequest
 */ export class AppendLandscapeHypothesisRequest extends Message {
    static fromBinary(bytes, options) {
        return new AppendLandscapeHypothesisRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendLandscapeHypothesisRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendLandscapeHypothesisRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendLandscapeHypothesisRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string hypothesis = 2;
   */ _define_property(this, "hypothesis", ""), /**
   * Compare-and-append; 0 is the initial revision. Stale writes return Aborted.
   *
   * @generated from field: int64 expected_revision = 3;
   */ _define_property(this, "expectedRevision", protoInt64.zero), /**
   * Reuse on retries of the same request (even after later versions exist).
   *
   * @generated from field: string request_id = 4;
   */ _define_property(this, "requestId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendLandscapeHypothesisRequest, "runtime", proto3);
_define_property(AppendLandscapeHypothesisRequest, "typeName", "mono.projectdata.v1.AppendLandscapeHypothesisRequest");
_define_property(AppendLandscapeHypothesisRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "hypothesis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "expected_revision",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "request_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AppendLandscapeHypothesisResponse
 */ export class AppendLandscapeHypothesisResponse extends Message {
    static fromBinary(bytes, options) {
        return new AppendLandscapeHypothesisResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AppendLandscapeHypothesisResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AppendLandscapeHypothesisResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AppendLandscapeHypothesisResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.HypothesisVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AppendLandscapeHypothesisResponse, "runtime", proto3);
_define_property(AppendLandscapeHypothesisResponse, "typeName", "mono.projectdata.v1.AppendLandscapeHypothesisResponse");
_define_property(AppendLandscapeHypothesisResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: HypothesisVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLandscapeIntelligenceRequest
 */ export class ListLandscapeIntelligenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeIntelligenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeIntelligenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeIntelligenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeIntelligenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * False: explicitly associated publications; true: current permitted picker.
   *
   * @generated from field: bool selectable = 2;
   */ _define_property(this, "selectable", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeIntelligenceRequest, "runtime", proto3);
_define_property(ListLandscapeIntelligenceRequest, "typeName", "mono.projectdata.v1.ListLandscapeIntelligenceRequest");
_define_property(ListLandscapeIntelligenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "selectable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLandscapeIntelligenceResponse
 */ export class ListLandscapeIntelligenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeIntelligenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeIntelligenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeIntelligenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeIntelligenceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.LandscapeIntelligence intelligence = 1;
   */ _define_property(this, "intelligence", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeIntelligenceResponse, "runtime", proto3);
_define_property(ListLandscapeIntelligenceResponse, "typeName", "mono.projectdata.v1.ListLandscapeIntelligenceResponse");
_define_property(ListLandscapeIntelligenceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "intelligence",
            kind: "message",
            T: LandscapeIntelligence,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AssociateLandscapeIntelligenceRequest
 */ export class AssociateLandscapeIntelligenceRequest extends Message {
    static fromBinary(bytes, options) {
        return new AssociateLandscapeIntelligenceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssociateLandscapeIntelligenceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssociateLandscapeIntelligenceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssociateLandscapeIntelligenceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string library_item_id = 2;
   */ _define_property(this, "libraryItemId", ""), /**
   * @generated from field: string release_id = 3;
   */ _define_property(this, "releaseId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssociateLandscapeIntelligenceRequest, "runtime", proto3);
_define_property(AssociateLandscapeIntelligenceRequest, "typeName", "mono.projectdata.v1.AssociateLandscapeIntelligenceRequest");
_define_property(AssociateLandscapeIntelligenceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "library_item_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "release_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.AssociateLandscapeIntelligenceResponse
 */ export class AssociateLandscapeIntelligenceResponse extends Message {
    static fromBinary(bytes, options) {
        return new AssociateLandscapeIntelligenceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssociateLandscapeIntelligenceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssociateLandscapeIntelligenceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssociateLandscapeIntelligenceResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssociateLandscapeIntelligenceResponse, "runtime", proto3);
_define_property(AssociateLandscapeIntelligenceResponse, "typeName", "mono.projectdata.v1.AssociateLandscapeIntelligenceResponse");
_define_property(AssociateLandscapeIntelligenceResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * Known current Opportunities or known market observations, per kind/currency.
 * total_count includes unknowns; 0/0 denotes empty, never complete coverage.
 *
 * @generated from message mono.projectdata.v1.ComparisonCoverage
 */ export class ComparisonCoverage extends Message {
    static fromBinary(bytes, options) {
        return new ComparisonCoverage().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComparisonCoverage().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComparisonCoverage().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComparisonCoverage, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string currency = 2;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: int64 known_count = 3;
   */ _define_property(this, "knownCount", protoInt64.zero), /**
   * @generated from field: int64 total_count = 4;
   */ _define_property(this, "totalCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComparisonCoverage, "runtime", proto3);
_define_property(ComparisonCoverage, "typeName", "mono.projectdata.v1.ComparisonCoverage");
_define_property(ComparisonCoverage, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "known_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "total_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * SynthesisSource is a permitted source the answer may cite. kind is
 * current_value or market_observation.
 *
 * @generated from message mono.projectdata.v1.SynthesisSource
 */ export class SynthesisSource extends Message {
    static fromBinary(bytes, options) {
        return new SynthesisSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SynthesisSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SynthesisSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SynthesisSource, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SynthesisSource, "runtime", proto3);
_define_property(SynthesisSource, "typeName", "mono.projectdata.v1.SynthesisSource");
_define_property(SynthesisSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SynthesisCaveat names a category of excluded or incomplete evidence. It
 * never carries counts or names of anything the caller cannot see.
 *
 * @generated from message mono.projectdata.v1.SynthesisCaveat
 */ export class SynthesisCaveat extends Message {
    static fromBinary(bytes, options) {
        return new SynthesisCaveat().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SynthesisCaveat().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SynthesisCaveat().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SynthesisCaveat, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category = 1;
   */ _define_property(this, "category", ""), /**
   * @generated from field: string message = 2;
   */ _define_property(this, "message", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SynthesisCaveat, "runtime", proto3);
_define_property(SynthesisCaveat, "typeName", "mono.projectdata.v1.SynthesisCaveat");
_define_property(SynthesisCaveat, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "message",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * SynthesisProposal is a suggestion only. kind is retain_observation,
 * create_profile or open_record. payload keys: retain_observation: text;
 * create_profile: name; open_record: opportunity_id.
 *
 * @generated from message mono.projectdata.v1.SynthesisProposal
 */ export class SynthesisProposal extends Message {
    static fromBinary(bytes, options) {
        return new SynthesisProposal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SynthesisProposal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SynthesisProposal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SynthesisProposal, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: map<string, string> payload = 3;
   */ _define_property(this, "payload", {}), /**
   * @generated from field: repeated mono.projectdata.v1.SynthesisSource lineage = 4;
   */ _define_property(this, "lineage", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SynthesisProposal, "runtime", proto3);
_define_property(SynthesisProposal, "typeName", "mono.projectdata.v1.SynthesisProposal");
_define_property(SynthesisProposal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "payload",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 9 /* ScalarType.STRING */ 
            }
        },
        {
            no: 4,
            name: "lineage",
            kind: "message",
            T: SynthesisSource,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeSynthesisRequest
 */ export class GetLandscapeSynthesisRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeSynthesisRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeSynthesisRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeSynthesisRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeSynthesisRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string question = 2;
   */ _define_property(this, "question", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeSynthesisRequest, "runtime", proto3);
_define_property(GetLandscapeSynthesisRequest, "typeName", "mono.projectdata.v1.GetLandscapeSynthesisRequest");
_define_property(GetLandscapeSynthesisRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeSynthesisResponse
 */ export class GetLandscapeSynthesisResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeSynthesisResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeSynthesisResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeSynthesisResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeSynthesisResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string answer = 1;
   */ _define_property(this, "answer", ""), /**
   * @generated from field: string provider = 2;
   */ _define_property(this, "provider", ""), /**
   * @generated from field: repeated mono.projectdata.v1.SynthesisSource sources = 3;
   */ _define_property(this, "sources", []), /**
   * Computed server-side from the canonical projection, never by the model.
   *
   * @generated from field: mono.projectdata.v1.EconomicsFigures totals = 4;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.MoneyTotal market_totals = 5;
   */ _define_property(this, "marketTotals", []), /**
   * @generated from field: repeated mono.projectdata.v1.SynthesisCaveat caveats = 6;
   */ _define_property(this, "caveats", []), /**
   * @generated from field: repeated mono.projectdata.v1.SynthesisProposal proposals = 7;
   */ _define_property(this, "proposals", []), /**
   * @generated from field: string audit_id = 8;
   */ _define_property(this, "auditId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeSynthesisResponse, "runtime", proto3);
_define_property(GetLandscapeSynthesisResponse, "typeName", "mono.projectdata.v1.GetLandscapeSynthesisResponse");
_define_property(GetLandscapeSynthesisResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "answer",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "provider",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sources",
            kind: "message",
            T: SynthesisSource,
            repeated: true
        },
        {
            no: 4,
            name: "totals",
            kind: "message",
            T: EconomicsFigures
        },
        {
            no: 5,
            name: "market_totals",
            kind: "message",
            T: MoneyTotal,
            repeated: true
        },
        {
            no: 6,
            name: "caveats",
            kind: "message",
            T: SynthesisCaveat,
            repeated: true
        },
        {
            no: 7,
            name: "proposals",
            kind: "message",
            T: SynthesisProposal,
            repeated: true
        },
        {
            no: 8,
            name: "audit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RetainLandscapeObservationRequest
 */ export class RetainLandscapeObservationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RetainLandscapeObservationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetainLandscapeObservationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetainLandscapeObservationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetainLandscapeObservationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * Must be a subset of sources the caller may currently read.
   *
   * @generated from field: repeated mono.projectdata.v1.SynthesisSource lineage = 3;
   */ _define_property(this, "lineage", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetainLandscapeObservationRequest, "runtime", proto3);
_define_property(RetainLandscapeObservationRequest, "typeName", "mono.projectdata.v1.RetainLandscapeObservationRequest");
_define_property(RetainLandscapeObservationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lineage",
            kind: "message",
            T: SynthesisSource,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RetainLandscapeObservationResponse
 */ export class RetainLandscapeObservationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RetainLandscapeObservationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RetainLandscapeObservationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RetainLandscapeObservationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RetainLandscapeObservationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string text = 2;
   */ _define_property(this, "text", ""), /**
   * @generated from field: repeated mono.projectdata.v1.SynthesisSource lineage = 3;
   */ _define_property(this, "lineage", []), /**
   * @generated from field: string created_by = 4;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: string created_at = 5;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RetainLandscapeObservationResponse, "runtime", proto3);
_define_property(RetainLandscapeObservationResponse, "typeName", "mono.projectdata.v1.RetainLandscapeObservationResponse");
_define_property(RetainLandscapeObservationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lineage",
            kind: "message",
            T: SynthesisSource,
            repeated: true
        },
        {
            no: 4,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LandscapeReportScope identifies what a report's content was computed over.
 * kind "portfolio" means every live Landscape, deduplicated on Opportunity;
 * kind "landscape" scopes to one Landscape (landscape_id/landscape_name).
 *
 * @generated from message mono.projectdata.v1.LandscapeReportScope
 */ export class LandscapeReportScope extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeReportScope().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeReportScope().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeReportScope().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeReportScope, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string landscape_name = 3;
   */ _define_property(this, "landscapeName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeReportScope, "runtime", proto3);
_define_property(LandscapeReportScope, "typeName", "mono.projectdata.v1.LandscapeReportScope");
_define_property(LandscapeReportScope, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "landscape_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReportValueDefinition is fixed, server-authored text (one per value kind)
 * stating what the figure means, that kinds are never summed together, and
 * that currencies are never converted between each other.
 *
 * @generated from message mono.projectdata.v1.ReportValueDefinition
 */ export class ReportValueDefinition extends Message {
    static fromBinary(bytes, options) {
        return new ReportValueDefinition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReportValueDefinition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReportValueDefinition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReportValueDefinition, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string definition = 3;
   */ _define_property(this, "definition", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReportValueDefinition, "runtime", proto3);
_define_property(ReportValueDefinition, "typeName", "mono.projectdata.v1.ReportValueDefinition");
_define_property(ReportValueDefinition, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "definition",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReportCoverageLine: known_count is the distinct in-scope Opportunities
 * carrying a live value of this kind/currency; total_count is every
 * Opportunity in scope, so an unknown Opportunity is never presented as a
 * zero-valued row.
 *
 * @generated from message mono.projectdata.v1.ReportCoverageLine
 */ export class ReportCoverageLine extends Message {
    static fromBinary(bytes, options) {
        return new ReportCoverageLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReportCoverageLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReportCoverageLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReportCoverageLine, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string currency = 2;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: int64 known_count = 3;
   */ _define_property(this, "knownCount", protoInt64.zero), /**
   * @generated from field: int64 total_count = 4;
   */ _define_property(this, "totalCount", protoInt64.zero);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReportCoverageLine, "runtime", proto3);
_define_property(ReportCoverageLine, "typeName", "mono.projectdata.v1.ReportCoverageLine");
_define_property(ReportCoverageLine, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "known_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "total_count",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        }
    ]));
/**
 * ReportSelectedVersion freezes one constituent row the figures (or the
 * analysis) were built from. Field relevance depends on source_kind: an
 * opportunity_value row carries opportunity_id/lot_id/kind/amount/currency; a
 * hypothesis row carries id/version/as_of/title; an intelligence_release row
 * carries id/version/title/provenance; a market_observation carries
 * id/amount/currency/as_of/title/provenance.
 *
 * @generated from message mono.projectdata.v1.ReportSelectedVersion
 */ export class ReportSelectedVersion extends Message {
    static fromBinary(bytes, options) {
        return new ReportSelectedVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReportSelectedVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReportSelectedVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReportSelectedVersion, a, b);
    }
    constructor(data){
        super(), /**
   * opportunity_value | hypothesis | intelligence_release | market_observation
   *
   * @generated from field: string source_kind = 1;
   */ _define_property(this, "sourceKind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 3;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string lot_id = 4;
   */ _define_property(this, "lotId", ""), /**
   * @generated from field: string kind = 5;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string amount = 6;
   */ _define_property(this, "amount", ""), /**
   * @generated from field: string currency = 7;
   */ _define_property(this, "currency", ""), /**
   * @generated from field: string version = 8;
   */ _define_property(this, "version", ""), /**
   * @generated from field: string as_of = 9;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: string provenance = 10;
   */ _define_property(this, "provenance", ""), /**
   * @generated from field: string title = 11;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReportSelectedVersion, "runtime", proto3);
_define_property(ReportSelectedVersion, "typeName", "mono.projectdata.v1.ReportSelectedVersion");
_define_property(ReportSelectedVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source_kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lot_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "currency",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "provenance",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * ReportChange freezes one growth_landscape_member_events row observed inside
 * the report's (as_of - window_days, as_of] window.
 *
 * @generated from message mono.projectdata.v1.ReportChange
 */ export class ReportChange extends Message {
    static fromBinary(bytes, options) {
        return new ReportChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReportChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReportChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReportChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string opportunity_id = 2;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: string action = 3;
   */ _define_property(this, "action", ""), /**
   * @generated from field: string basis = 4;
   */ _define_property(this, "basis", ""), /**
   * @generated from field: string actor = 5;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string reason = 6;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: string occurred_at = 7;
   */ _define_property(this, "occurredAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReportChange, "runtime", proto3);
_define_property(ReportChange, "typeName", "mono.projectdata.v1.ReportChange");
_define_property(ReportChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "action",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "occurred_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LandscapeReportContent is the entire frozen snapshot: reopening an old
 * version always reconstructs this exact message, regardless of later edits
 * to the underlying economics, hypotheses, intelligence or membership.
 *
 * @generated from message mono.projectdata.v1.LandscapeReportContent
 */ export class LandscapeReportContent extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeReportContent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeReportContent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeReportContent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeReportContent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LandscapeReportScope scope = 1;
   */ _define_property(this, "scope", void 0), /**
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string as_of = 3;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: int32 window_days = 4;
   */ _define_property(this, "windowDays", 0), /**
   * @generated from field: mono.projectdata.v1.EconomicsFigures figures = 5;
   */ _define_property(this, "figures", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.ReportValueDefinition value_definitions = 6;
   */ _define_property(this, "valueDefinitions", []), /**
   * @generated from field: repeated mono.projectdata.v1.ReportCoverageLine coverage = 7;
   */ _define_property(this, "coverage", []), /**
   * @generated from field: repeated mono.projectdata.v1.ReportSelectedVersion selected_versions = 8;
   */ _define_property(this, "selectedVersions", []), /**
   * @generated from field: repeated mono.projectdata.v1.ReportChange changes = 9;
   */ _define_property(this, "changes", []), /**
   * The caller-visible project sets the figures were computed against, frozen
   * so a later authorization change cannot silently reinterpret this version.
   *
   * @generated from field: repeated string selected_pursuit_project_ids = 10;
   */ _define_property(this, "selectedPursuitProjectIds", []), /**
   * @generated from field: repeated string selected_proposal_project_ids = 11;
   */ _define_property(this, "selectedProposalProjectIds", []), /**
   * @generated from field: int64 opportunities_in_scope = 12;
   */ _define_property(this, "opportunitiesInScope", protoInt64.zero), /**
   * @generated from field: int64 opportunities_missing_values = 13;
   */ _define_property(this, "opportunitiesMissingValues", protoInt64.zero), /**
   * @generated from field: string generated_by = 14;
   */ _define_property(this, "generatedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeReportContent, "runtime", proto3);
_define_property(LandscapeReportContent, "typeName", "mono.projectdata.v1.LandscapeReportContent");
_define_property(LandscapeReportContent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scope",
            kind: "message",
            T: LandscapeReportScope
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "window_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "figures",
            kind: "message",
            T: EconomicsFigures
        },
        {
            no: 6,
            name: "value_definitions",
            kind: "message",
            T: ReportValueDefinition,
            repeated: true
        },
        {
            no: 7,
            name: "coverage",
            kind: "message",
            T: ReportCoverageLine,
            repeated: true
        },
        {
            no: 8,
            name: "selected_versions",
            kind: "message",
            T: ReportSelectedVersion,
            repeated: true
        },
        {
            no: 9,
            name: "changes",
            kind: "message",
            T: ReportChange,
            repeated: true
        },
        {
            no: 10,
            name: "selected_pursuit_project_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 11,
            name: "selected_proposal_project_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 12,
            name: "opportunities_in_scope",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 13,
            name: "opportunities_missing_values",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 14,
            name: "generated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * LandscapeReportPresentation is mutable: editing headline/note never touches
 * a version's frozen content.
 *
 * @generated from message mono.projectdata.v1.LandscapeReportPresentation
 */ export class LandscapeReportPresentation extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeReportPresentation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeReportPresentation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeReportPresentation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeReportPresentation, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string headline = 1;
   */ _define_property(this, "headline", ""), /**
   * @generated from field: string note = 2;
   */ _define_property(this, "note", ""), /**
   * @generated from field: string updated_at = 3;
   */ _define_property(this, "updatedAt", ""), /**
   * @generated from field: string updated_by = 4;
   */ _define_property(this, "updatedBy", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeReportPresentation, "runtime", proto3);
_define_property(LandscapeReportPresentation, "typeName", "mono.projectdata.v1.LandscapeReportPresentation");
_define_property(LandscapeReportPresentation, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "headline",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "updated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LandscapeReportVersion
 */ export class LandscapeReportVersion extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeReportVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeReportVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeReportVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeReportVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string report_id = 3;
   */ _define_property(this, "reportId", ""), /**
   * @generated from field: int32 version = 4;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string title = 5;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string created_at = 6;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: mono.projectdata.v1.LandscapeReportContent content = 8;
   */ _define_property(this, "content", void 0), /**
   * @generated from field: mono.projectdata.v1.LandscapeReportPresentation presentation = 9;
   */ _define_property(this, "presentation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeReportVersion, "runtime", proto3);
_define_property(LandscapeReportVersion, "typeName", "mono.projectdata.v1.LandscapeReportVersion");
_define_property(LandscapeReportVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "report_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "content",
            kind: "message",
            T: LandscapeReportContent
        },
        {
            no: 9,
            name: "presentation",
            kind: "message",
            T: LandscapeReportPresentation
        }
    ]));
/**
 * LandscapeReportVersionRef is one entry in a report's version history list,
 * without the full (potentially large) content payload.
 *
 * @generated from message mono.projectdata.v1.LandscapeReportVersionRef
 */ export class LandscapeReportVersionRef extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeReportVersionRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeReportVersionRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeReportVersionRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeReportVersionRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * @generated from field: string created_at = 3;
   */ _define_property(this, "createdAt", ""), /**
   * @generated from field: string as_of = 4;
   */ _define_property(this, "asOf", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeReportVersionRef, "runtime", proto3);
_define_property(LandscapeReportVersionRef, "typeName", "mono.projectdata.v1.LandscapeReportVersionRef");
_define_property(LandscapeReportVersionRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.LandscapeReportSummary
 */ export class LandscapeReportSummary extends Message {
    static fromBinary(bytes, options) {
        return new LandscapeReportSummary().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LandscapeReportSummary().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LandscapeReportSummary().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LandscapeReportSummary, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string report_id = 1;
   */ _define_property(this, "reportId", ""), /**
   * @generated from field: string landscape_id = 2;
   */ _define_property(this, "landscapeId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string template_id = 4;
   */ _define_property(this, "templateId", ""), /**
   * @generated from field: string as_of = 5;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: int32 latest_version = 6;
   */ _define_property(this, "latestVersion", 0), /**
   * @generated from field: string latest_version_id = 7;
   */ _define_property(this, "latestVersionId", ""), /**
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(LandscapeReportSummary, "runtime", proto3);
_define_property(LandscapeReportSummary, "typeName", "mono.projectdata.v1.LandscapeReportSummary");
_define_property(LandscapeReportSummary, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "report_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "latest_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "latest_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GenerateLandscapeReportRequest
 */ export class GenerateLandscapeReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateLandscapeReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateLandscapeReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateLandscapeReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateLandscapeReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty = portfolio scope (every live Landscape, deduplicated).
   *
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", ""), /**
   * review-brief-v1 | economics-only-v1
   *
   * @generated from field: string template_id = 2;
   */ _define_property(this, "templateId", ""), /**
   * Empty = now.
   *
   * @generated from field: string as_of = 3;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: int32 window_days = 4;
   */ _define_property(this, "windowDays", 0), /**
   * True: build and return content without writing a version row.
   *
   * @generated from field: bool preview = 5;
   */ _define_property(this, "preview", false), /**
   * Empty = a fresh report (version 1); set = append the next version to it.
   *
   * @generated from field: string report_id = 6;
   */ _define_property(this, "reportId", ""), /**
   * @generated from field: string title = 7;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateLandscapeReportRequest, "runtime", proto3);
_define_property(GenerateLandscapeReportRequest, "typeName", "mono.projectdata.v1.GenerateLandscapeReportRequest");
_define_property(GenerateLandscapeReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "template_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "window_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "preview",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "report_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GenerateLandscapeReportResponse
 */ export class GenerateLandscapeReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateLandscapeReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateLandscapeReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateLandscapeReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateLandscapeReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LandscapeReportVersion version = 1;
   */ _define_property(this, "version", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateLandscapeReportResponse, "runtime", proto3);
_define_property(GenerateLandscapeReportResponse, "typeName", "mono.projectdata.v1.GenerateLandscapeReportResponse");
_define_property(GenerateLandscapeReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: LandscapeReportVersion
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLandscapeReportsRequest
 */ export class ListLandscapeReportsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeReportsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeReportsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeReportsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeReportsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * Empty = every report in the tenant, portfolio and Landscape scoped alike.
   *
   * @generated from field: string landscape_id = 1;
   */ _define_property(this, "landscapeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeReportsRequest, "runtime", proto3);
_define_property(ListLandscapeReportsRequest, "typeName", "mono.projectdata.v1.ListLandscapeReportsRequest");
_define_property(ListLandscapeReportsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "landscape_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListLandscapeReportsResponse
 */ export class ListLandscapeReportsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListLandscapeReportsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListLandscapeReportsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListLandscapeReportsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListLandscapeReportsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.LandscapeReportSummary reports = 1;
   */ _define_property(this, "reports", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListLandscapeReportsResponse, "runtime", proto3);
_define_property(ListLandscapeReportsResponse, "typeName", "mono.projectdata.v1.ListLandscapeReportsResponse");
_define_property(ListLandscapeReportsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "reports",
            kind: "message",
            T: LandscapeReportSummary,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeReportRequest
 */ export class GetLandscapeReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string report_id = 1;
   */ _define_property(this, "reportId", ""), /**
   * 0 = latest.
   *
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * Set = fetch this exact version row directly; takes precedence over report_id/version.
   *
   * @generated from field: string version_id = 3;
   */ _define_property(this, "versionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeReportRequest, "runtime", proto3);
_define_property(GetLandscapeReportRequest, "typeName", "mono.projectdata.v1.GetLandscapeReportRequest");
_define_property(GetLandscapeReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "report_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetLandscapeReportResponse
 */ export class GetLandscapeReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetLandscapeReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetLandscapeReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetLandscapeReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetLandscapeReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LandscapeReportVersion version = 1;
   */ _define_property(this, "version", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.LandscapeReportVersionRef versions = 2;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetLandscapeReportResponse, "runtime", proto3);
_define_property(GetLandscapeReportResponse, "typeName", "mono.projectdata.v1.GetLandscapeReportResponse");
_define_property(GetLandscapeReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version",
            kind: "message",
            T: LandscapeReportVersion
        },
        {
            no: 2,
            name: "versions",
            kind: "message",
            T: LandscapeReportVersionRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveLandscapeReportPresentationRequest
 */ export class SaveLandscapeReportPresentationRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveLandscapeReportPresentationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveLandscapeReportPresentationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveLandscapeReportPresentationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveLandscapeReportPresentationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * @generated from field: string headline = 2;
   */ _define_property(this, "headline", ""), /**
   * @generated from field: string note = 3;
   */ _define_property(this, "note", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveLandscapeReportPresentationRequest, "runtime", proto3);
_define_property(SaveLandscapeReportPresentationRequest, "typeName", "mono.projectdata.v1.SaveLandscapeReportPresentationRequest");
_define_property(SaveLandscapeReportPresentationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "headline",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SaveLandscapeReportPresentationResponse
 */ export class SaveLandscapeReportPresentationResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveLandscapeReportPresentationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveLandscapeReportPresentationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveLandscapeReportPresentationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveLandscapeReportPresentationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.LandscapeReportPresentation presentation = 1;
   */ _define_property(this, "presentation", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveLandscapeReportPresentationResponse, "runtime", proto3);
_define_property(SaveLandscapeReportPresentationResponse, "typeName", "mono.projectdata.v1.SaveLandscapeReportPresentationResponse");
_define_property(SaveLandscapeReportPresentationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "presentation",
            kind: "message",
            T: LandscapeReportPresentation
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExportLandscapeReportRequest
 */ export class ExportLandscapeReportRequest extends Message {
    static fromBinary(bytes, options) {
        return new ExportLandscapeReportRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportLandscapeReportRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportLandscapeReportRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportLandscapeReportRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string version_id = 1;
   */ _define_property(this, "versionId", ""), /**
   * Empty or "csv" = CSV; any other value is InvalidArgument.
   *
   * @generated from field: string format = 2;
   */ _define_property(this, "format", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportLandscapeReportRequest, "runtime", proto3);
_define_property(ExportLandscapeReportRequest, "typeName", "mono.projectdata.v1.ExportLandscapeReportRequest");
_define_property(ExportLandscapeReportRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "format",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ExportLandscapeReportResponse
 */ export class ExportLandscapeReportResponse extends Message {
    static fromBinary(bytes, options) {
        return new ExportLandscapeReportResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExportLandscapeReportResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExportLandscapeReportResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExportLandscapeReportResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string filename = 1;
   */ _define_property(this, "filename", ""), /**
   * @generated from field: string content_type = 2;
   */ _define_property(this, "contentType", ""), /**
   * @generated from field: bytes content = 3;
   */ _define_property(this, "content", new Uint8Array(0));
        proto3.util.initPartial(data, this);
    }
}
_define_property(ExportLandscapeReportResponse, "runtime", proto3);
_define_property(ExportLandscapeReportResponse, "typeName", "mono.projectdata.v1.ExportLandscapeReportResponse");
_define_property(ExportLandscapeReportResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "filename",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "content_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "content",
            kind: "scalar",
            T: 12 /* ScalarType.BYTES */ 
        }
    ]));
